import React, { useState, useEffect } from "react";
import ResultItems from "./Search/ResultItems";
import SearchBox from "./Search/SearchBox";
import MapLegend from "./Search/MapLegend";
import MapView from "./Search/MapView";

const reloadScript = (src) =>{
  // Create a new script element
  const newScript = document.createElement('script');
  newScript.src = src;

  // Find the existing script element in the DOM (the one you want to replace)
  const oldScript = document.querySelector('script[src="' + src + '"]');

  if (oldScript) {
    // Remove the old script element from the DOM
    oldScript.parentNode.removeChild(oldScript);
  }

  // Append the new script element to the document
  document.head.appendChild(newScript);
  const adsbyjuicy = window.adsbyjuicy || [];
  adsbyjuicy.push({'adzone':1030887});
  adsbyjuicy.push({'adzone':1030888});
  window.adsbyjuicy = adsbyjuicy;
}


const parseSearchParams = (searchString) => {
  const searchParams = new URLSearchParams(searchString);
  const initData = {};
  searchParams.forEach( (value, key) => {
    if (key.endsWith('[]')) {
      // Handle array parameter
      const paramName = key.slice(0, -2); // Remove the '[]' suffix
      const paramArray = searchParams.getAll(key); // Get all values for this parameter
      initData[paramName] = paramArray;
    } else {
      // Handle regular parameter
      initData[key] = value;
    }
  });
  return initData;
}

const serializeParams = (data) => {
  const cleanedData = {};
  Object.keys(data).map((key) => {
    if(!!data[key]) {
      cleanedData[key] = data[key];
    }
  })
  const { amenities, ...newData } = cleanedData;
  let urlParams = new URLSearchParams({ ...newData }).toString();
  if(!amenities || amenities.length === 0) return urlParams;

  amenities.forEach((amenity, index) => {
    urlParams =
      `${urlParams}&` +
      encodeURIComponent("amenities[]") +
      "=" +
      encodeURIComponent(amenity);
  });
  return urlParams;
}

const synceUrlParams = (data) => {
  const urlParams = serializeParams(data);
  window.history.pushState(
    "",
    "",
    `?${urlParams}`
  );
}

const SearchListings = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [hoveringItem, setHoveringItem] = useState(null);
  const [filters, setFilters] = useState({
    viewing: "grid",
    sort: "",
    q: "",
    amenities: [],
    page: 1
  });

  const [results, setResults] = useState([]);
  const [resultMeta, setResultMeta] = useState({});
  const parseResults = (resources) => {
    const categories = (window.searchData?.categories || []);
    return resources.map((resource) => {
      const category = categories.find((cat) => cat.name.toLocaleLowerCase() === resource.categories[0].toLocaleLowerCase());
      if(category) {
        return {
          ...resource,
          marker_url: category.normal_image_url,
          selected_marker_url: category.normal_image_url,          
        }
      } 
      return resource;
    })
  }
  const doSearch = async (data) => {
    setIsLoading(true);
    const urlParams = serializeParams(data);
    const resp = await fetch(`/listing/search.json?${urlParams}`);
    const response = await resp.json();
    const { resources, meta } = response;
    setResults(parseResults(resources));
    setResultMeta(meta);
    setIsLoading(false);
    synceUrlParams(data);
    
  };

  const handleSearch = (data) => {
    const newFilters = {...filters, ...data};
    const { lat, lng, ...restFilters} = newFilters;
    console.log('handleSearch', data, newFilters);
    setFilters({ ...restFilters });
    doSearch({ ...restFilters });
  };

  const handleSort = (data) => {
    setFilters({ ...filters, sort: data });
    doSearch({ ...filters, sort: data });
  };

  const reloadAds = () => {
    setTimeout(() => {
      reloadScript(`https://poweredby.jads.co/js/jads.js`);
    }, 1000)
  }
  const handleSwitchView = (viewing) => {
    setFilters({ ...filters, viewing });
    synceUrlParams({ ...filters, viewing });
    reloadAds();
  };

  const handleMapZoom = (mapViewPort) => {
    if(isLoading) return false;
    console.log('filters', filters, mapViewPort)
    // setFilters({ ...filters, zoom: mapViewPort.zoom, lat: mapViewPort.center.lat, lng: mapViewPort.center.lng });
    doSearch({ ...filters, zoom: mapViewPort.zoom, lat: mapViewPort.center.lat, lng: mapViewPort.center.lng });
    synceUrlParams({ ...filters, zoom: mapViewPort.zoom });
  };
  
  useEffect(() => {
    const initFilters = parseSearchParams(location.search);
    const categoryGroups = (window.searchData?.categories || [])
    const defCat = categoryGroups.find((cat) => (cat.slug === initFilters.category))
    const newFilters = {
      ...filters, ...initFilters, 
      category: defCat?.slug ? defCat.slug : initFilters.category,
      page: 1
    };
    doSearch(newFilters);
    setFilters({...newFilters,});
    reloadAds();
  }, []);

  return (
    <div className={`fs-container ${isCollapsed ? "is-collapsed" : ""}`}>
      <div className="fs-inner-container content">
        <SearchBox
          filters={filters}
          onSearch={handleSearch}
          isLoading={isLoading}
        />
        <ResultItems
          results={results}
          resultMeta={resultMeta}
          onSort={handleSort}
          onSwitchView={handleSwitchView}
          filters={filters}
          isLoading={isLoading}
          onHover={item => setHoveringItem(item)}
        />
      </div>
      <div className="fs-inner-container map-fixed">
        <div id="utf_map_container">
          <div
            className="map-switcher"
            onClick={(e) => setIsCollapsed(!isCollapsed)}
          >
            <i className="sl sl-icon-arrow-left"></i>
            <i className="sl sl-icon-arrow-right"></i>
          </div>
          <MapLegend/>
          <MapView 
            results={results} 
            hoveringItem={hoveringItem}
            zoom={filters.zoom || 8}
            onChange={handleMapZoom}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchListings;
